import LogoCnEnSrc from "./logo-cn-en.svg";
import LogoCnSrc from "./logo-cn.svg";
import React from "react";

type IProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

const YituCnEnLogoImg = (props: IProps) => {
  return <img src={LogoCnEnSrc} {...props} />;
};

const YituCnLogoImg = (props: IProps) => {
  return <img src={LogoCnSrc} {...props} />;
};

export const YituLogoImg = {
  CnEn: YituCnEnLogoImg,
  Cn: YituCnLogoImg
};
